<template>
  <div class="header-section">
    <form
      v-if="canPrintInvoices"
      :action="model.exportAction"
      method="POST"
      target="_blank"
    >
      <input type="hidden" name="accountId" :value="model.accountId">
      <input type="hidden" name="userId" :value="model.userId">
      <input type="hidden" name="invoices" :value="model.exportKey">
      <div class="row mb-2">
        <div class="col-md-2 col-xs-12 col-sm-12">
          <b-button
            type="submit"
            class="btn-print mb-1"
            name="format" 
            :value="'PDF'" 
            size="sm"        
          >
            {{ getContentItem("exportAsPDF") }}
          </b-button>
          <b-button
            v-if="canPrintInvoices"
            type="submit"
            class="btn-print mb-1"
            name="format" 
            :value="'Excel'" 
            size="sm"
          >
            {{ getContentItem("ExportToExcel") }}
          </b-button>
        </div>
      </div>
    </form>
    <h3 class="muted pull-right">
      Invoiced {{ model.invoiceDate }}
    </h3>
    <h1>Invoice #{{ model.invoiceNumber }}</h1>
    <b-card-group deck class="mb-4">
      <b-card :title="getContentItem('billTo')" bg-variant="light">
        <PostalAddress :address="model.billTo" />
      </b-card>
      <b-card :title="getContentItem('otherInfo')" bg-variant="light">
        <div v-if="model.showWarehouse">
          <static-form-control
            id="warehouse-number"
            :label-text="getContentItem('Warehouse')"
            :value="model.warehouseNumber"
            :cols="5"
            :margin="2"
          />
        </div>
        <div v-if="model.showReferenceNumbers">
          <static-form-control
            id="purchase-order-numbers"
            :label-text="getContentItem('purchaseOrderNumber')"
            :value="model.purchaseOrderNumber"
            :cols="5"
            :margin="2"
          />
          <static-form-control
            id="onebill-reference-numbers"
            :v-if="model.dealerClaimAmount > 0"
            :label-text="getContentItem('OneBillInvoiceNumber')"
            :value="model.oneBillReferenceNumber"
            :cols="5"
            :margin="2"
          />
          <static-form-control
            id="reference-numbers"
            :label-text="getContentItem('ShipToName')"
            :value="model.shipToName"
            :cols="5"
            :margin="2"
          />
        </div>
      </b-card>
    </b-card-group>
    <b-card-group 
      v-if="model.headerNotes.length > 0" 
      deck 
      class="mb-4"
    >
      <b-card :title="getContentItem('comments')" bg-variant="light"> 
        <b-row v-for="note in model.headerNotes" :key="note">
          <b-col xs="12" sm="6">
            <static-form-control
              id="note-type"
              :label-text="getContentItem('Type')"
              :value="note.NoteCategoryDescription"
              :cols="3"
            />
          </b-col>
          <b-col xs="12" sm="6">
            <static-form-control
              id="note"
              :label-text="getContentItem('Comment')"
              :value="note.OrderNote"
              :cols="3"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import { PostalAddress, StaticFormControl } from "@/components";

  export default {
    name: "DetailsHeader",
    components: {
      PostalAddress,
      StaticFormControl,
    },
    props: {
      model: Object,
    },
    computed: {
      ...mapGetters([
        "getContentItem", 
        "hasPermission",
        "IsMcfe"
      ]),
      canPrintInvoices() {
        return !this.hasPermission("HideInvoicePricing") && !this.IsMcfe;
      },
    },
  };
</script>
